<template>
  <div class="size size2">
    <div id="quick_menu" :class="showFloatingSmallButton ? 'sm' : ''">
      <div class="tp_wrap" v-show="!showFloatingSmallButton">
        <a
          role="button"
          class="quick_close"
          @click="showFloatingSmallButton = true"
        ></a>
        <swiper ref="mySwiper4" :options="swiperOptions4">
          <swiper-slide v-for="banner in bannerList" :key="banner.id">
            <a role="button" class="img" @click="goPage(banner.url)">
              <img :src="banner.image" />
              <span>{{ banner.name }}</span>
            </a>
          </swiper-slide>
        </swiper>
        <div class="swiper_btn clear">
          <div class="l_btn cursor">
            <img src="@/assets/images/q_left.jpg" />
          </div>
          <div class="r_btn cursor">
            <img src="@/assets/images/q_right.jpg" />
          </div>
        </div>
      </div>
      <div class="btm_wrap" v-show="!showFloatingSmallButton">
        <p>최근 본 상품</p>
        <div class="pr_wrap">
          <template v-if="viewProduct.length > 0">
            <a
              role="button"
              v-for="vp in viewProduct"
              :key="vp.id"
              @click="goProduct(vp.id)"
            >
              <p
                class="pic"
                :style="{
                  'background-image': 'url(' + vp.image + ')'
                }"
              >
                <img :src="vp.image" />
              </p>
            </a>
          </template>
          <template v-else>
            <p>최근 본 상품이 <em class="mbr"></em>존재하지 않습니다.</p>
          </template>
        </div>
        <router-link :to="{ name: 'favor' }" v-show="!showFloatingSmallButton">
          <img src="@/assets/images/hrt_ico.png" />
          <span>관심상품</span>
        </router-link>
      </div>
      <div class="sm_wrap" v-show="showFloatingSmallButton">
        <a role="button" @click="showFloatingSmallButton = false"></a>
      </div>
      <div class="top_btn">
        <a role="button" @click="$scrollSmoothToTop(10)">TOP</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecentlyViewProduct } from '@/utils/support'
import { advertiseList } from '@/api/homeData'

export default {
  name: 'FloatingMenu',
  data() {
    return {
      showFloatingSmallButton: false,
      swiperOptions4: {
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          prevEl: '.l_btn',
          nextEl: '.r_btn'
        }
      },
      bannerList: [],
      viewProduct: getRecentlyViewProduct()
    }
  },
  created() {
    this.getBannerList()
  },
  methods: {
    getBannerList() {
      advertiseList(2).then(res => {
        this.bannerList = res.data
      })
    },
    goPage(url) {
      if (url.match(/(http:\/\/)|(https:\/\/)/g)) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    },
    goProduct(id) {
      this.$router.push({ name: 'detail', params: { id: id } })
    }
  },
  mounted() {
    // event listener
    window.addEventListener('RVP-changed', event => {
      this.viewProduct = event.detail.storage
    })
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/layout/components/FloatingMenu.vue